import styled from 'styled-components';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import { GrAdd } from "react-icons/gr";
import { MdRemove } from "react-icons/md";
import { mobile } from '../responsive';
// import { useSelector } from 'react-redux';
// import StripeCheckout from "react-stripe-checkout"
// import { useEffect, useState } from 'react';
// import {userRequest} from "../requestMethods"
// import {useNavigate} from 'react-router-dom';

// const KEY = process.env.REACT_APP_STRIPE;
const KEY = "pk_test_51LCnnkSEzXF0AhfQiwUzzMSooZQ82fpw9QCCR84ZjfmWZBoUqPao0uqumjRlTxagDFT2KdU3vWAYGwcgL496S6Z100i3aRLrI0";

const Container = styled.div`
    
`
const Wrapper = styled.div`
    margin-top: 60px;
    
`
const Top = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    ${mobile({justifyContent:"space-around"})}
    
`
const Title = styled.h1`
    text-align: center;
    padding: 20px;
`

const TopButton = styled.button`
    padding: 10px;
    font-weight: 600;
    cursor: pointer;
    border: ${props => props.type === "filled" && "none"};
    background-color: ${props => props.type === "filled" ? "black" : "transparent"};
    color: ${props => props.type === "filled" && "white"};
`
const TopTexts = styled.div`
    ${mobile({display:"none"})}
`
const TopText = styled.span`
    text-decoration: underline;
    margin:0 10px;
    cursor: pointer;
`
const Buttom = styled.div`
    display: flex;
    justify-content: space-between;
    ${mobile({flexDirection:"column"})}
`
const Info = styled.div`
    flex: 3;
    ${mobile({marginBottom:"10px"})}
`
const Hr = styled.hr`
    color: grey;
`
const Product = styled.div`
    display: flex;
    justify-content: space-between;
    ${mobile({flexDirection:"column",margin:"10px"})}
`
const ProductDetail = styled.div`
    flex: 2;
    display: flex;
`
const Image = styled.img`
    width: 200px;
`
const Details = styled.div`
    padding: 20px;
    display: flex;
    justify-content: space-around;
    flex-direction: column;
`
const ProductName = styled.span`
    
`
const ProductId = styled.span`
  
   display: flex;
   flex-wrap: wrap;
   overflow: hidden;
    
`
const ProductColorContainer = styled.div`
    display: flex;
`
const ProductColor = styled.div`
    width: 20px;
    height: 20px;
    border-radius:50%;
    background-color: ${props => props.color};
    margin-right: 10px;

`
const ProductSize = styled.span`
    
`
const PriceDetail = styled.div`
    flex:1;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction:column;
`


const ProductAmountContainer = styled.div`
   display: flex;
   align-items: center;
   font-weight: 600;
   margin-bottom: 20px;
`

const ProductAmount = styled.div`
   font-size: 24px;
   padding: 10px;
`
const ProductPrice = styled.div`
   font-size: 30px;
   font-weight: 700;
`
const Summary = styled.div`
    flex: 1;
   border: 0.5px solid lightgray;
   border-radius: 10px;
   padding: 20px;
   height: 60vh;
`
const SummaryTitle = styled.h1`
    font-weight: 200;
   
`
const SummaryItem = styled.div`
    margin: 20px 0;
    display: flex;
    justify-content: space-between;
    font-weight: ${props => props.type === "total" && "700"};
    font-size: ${props => props.type === "total" && "24px"};
`
const SummaryItemText = styled.span`
    
   
`
const SummaryItemPrice = styled.span`
    
   
`
const Button = styled.button`
    width: 100%;
    padding: 10px;
    background-color: #000;
    color: #fff;

   
`
const Cart = () => {
    // const navigate = useNavigate();
    
    return (
        <>
            <Container>
                <Navbar />
                <Wrapper>
                    <Title>Your Bag</Title>
                    <Top>
                        <TopButton>CONTINUE SHOPPING</TopButton>
                        <TopTexts>
                            <TopText>Shopping Bag(2)</TopText>
                            <TopText>Your WishList(0)</TopText>
                        </TopTexts>
                        <TopButton type='filled'>CHECKOUT</TopButton>
                    </Top>
                    <Buttom>
                        <Info>
                            
                              <Product >
                                <ProductDetail>
                                    <Image src="https://static.zajo.net/content/mediagallery/zajo_dcat/image/product/types/X/9088.png"></Image>
                                    <Details>
                                        <ProductName> <b>Prodcut : </b>Men T-shirt</ProductName>
                                        <ProductId> <b>ID:</b> 14258696</ProductId>
                                        <ProductColorContainer>
                                          <b>Color: </b> <ProductColor color="red" />
                                            
                                        </ProductColorContainer>
                                        <ProductSize> <b>Size : </b>L</ProductSize>
                                    </Details>
                                </ProductDetail>
                                <PriceDetail>
                                    <ProductAmountContainer>
                                        <GrAdd />
                                        <ProductAmount>2</ProductAmount>
                                        <MdRemove />
                                    </ProductAmountContainer>
                                    
                                    <ProductPrice>
                                        $ 349
                                    </ProductPrice>
                                </PriceDetail>
                            </Product>
                               <Hr />
                              <Product >
                                <ProductDetail>
                                    <Image src="https://assets.ajio.com/medias/sys_master/root/20220121/DwGv/61ea58afaeb2695cdd2436ee/-473Wx593H-461575169-maroon-MODEL.jpg"></Image>
                                    <Details>
                                        <ProductName> <b>Prodcut : </b>Men T-shirt</ProductName>
                                        <ProductId> <b>ID:</b> 14258625</ProductId>
                                        <ProductColorContainer>
                                          <b>Color: </b> 
                                          <ProductColor color="gray" />
                                          <ProductColor color="blue" />
                                            
                                        </ProductColorContainer>
                                        <ProductSize> <b>Size : </b>M</ProductSize>
                                    </Details>
                                </ProductDetail>
                                <PriceDetail>
                                    <ProductAmountContainer>
                                        <GrAdd />
                                        <ProductAmount>1</ProductAmount>
                                        <MdRemove />
                                    </ProductAmountContainer>
                                    
                                    <ProductPrice>
                                        $ 400
                                    </ProductPrice>
                                </PriceDetail>
                            </Product>
                             
                        </Info>
                        <Summary>
                            <SummaryTitle>ORDER SUMMARY </SummaryTitle>
                            <SummaryItem>
                                <SummaryItemText>SubTotal</SummaryItemText>
                                <SummaryItemPrice>$ 749</SummaryItemPrice>
                            </SummaryItem>
                            <SummaryItem>
                                <SummaryItemText>Estimate Shipping</SummaryItemText>
                                <SummaryItemPrice>$ 5</SummaryItemPrice>
                            </SummaryItem>
                            <SummaryItem>
                                <SummaryItemText>Shipping Discount</SummaryItemText>
                                <SummaryItemPrice>$ -5</SummaryItemPrice>
                            </SummaryItem>
                            <SummaryItem type="total">
                                <SummaryItemText >Total</SummaryItemText>
                                <SummaryItemPrice>$ 749</SummaryItemPrice>
                            </SummaryItem>                               
                            <Button>CHECKOUT NOW</Button>                           
                        </Summary>
                    </Buttom>
                </Wrapper>
                <Footer />
            </Container>
        </>
    )
}

export default Cart;